import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { SetupAccountComponent } from './setup-account/setup-account.component';
import { MicrosoftCallbackComponent } from './microsoft-callback/microsoft-callback.component';
import { GoogleCallbackComponent } from './google-callback/google-callback.component';
import { PublicLayoutComponent } from './_layout/public-layout/public-layout.component';
import { PrivateLayoutComponent } from './_layout/private-layout/private-layout.component';
import { IsSecureGuard } from './shared/is-secure.guard';
import { AuthGuard } from './login/auth.guard';
import { InactivityGuard } from './guards/inactivity.guard';
import { IntroComponent } from './intro/intro.component';
import { LexgosignEnabledGuard } from './inprovider-sign/lexgosign-enabled.guard';
import { ForceChangePasswordComponent } from './force-change-password/force-change-password.component';

const appRoutes: Routes = [
	// Public layout
	{
	  path: '',
	  component: PublicLayoutComponent,
	  children: [
		{ path: '', component: LoginComponent },
		{ path: 'login', component: LoginComponent, canActivate: [IsSecureGuard]},
		{ path: 'setup-account/:token', component: SetupAccountComponent },
		{ path: 'microsoft-callback', component: MicrosoftCallbackComponent },
		{ path: 'google-callback', component: GoogleCallbackComponent },
		{ path: 'intro',component: IntroComponent, canActivate: [AuthGuard, IsSecureGuard, InactivityGuard]},
		{ path: 'change-password', component: ForceChangePasswordComponent, canActivate: [AuthGuard, IsSecureGuard, InactivityGuard]},
		{ path: 'calendar-callback', loadChildren: () => import('./calendar-callback/calendar-callback.module').then(m => m.CalendarCallbackModule) },

	  ]
	},
	{
	  path: '',
	  component: PrivateLayoutComponent,
	  children: [
		{
			path: 'logout', component: LoginComponent,
			canActivate: [AuthGuard]
		},
		{
			path: 'flows', loadChildren: () => import('./trackvision/flows.module').then(m => m.FlowsModule),
			canActivate: [AuthGuard, IsSecureGuard, InactivityGuard]
		},
		{
			path: 'services', loadChildren: () => import('./inp-services/services.module').then(m => m.ServicesModule),
			canActivate: [AuthGuard, IsSecureGuard, InactivityGuard]
		},
		{
			path: 'legal-analytics', loadChildren: () => import('./legal-analytics/legal-analytics.module').then(m => m.LegalAnalyticsModule),
			canActivate: [AuthGuard, IsSecureGuard, InactivityGuard]
		},
		{
			path: 'pjud-indicators',
			loadChildren: () => import('./pjud-indicators/pjud-indicators.module').then(m => m.PjudIndicatorsModule),
			canActivate: [AuthGuard, IsSecureGuard, InactivityGuard]
		},
		{
			path: 'mis-actividades', loadChildren: () => import('./calendar/calendar.module').then(m => m.CalendarModule),
			canActivate: [AuthGuard, IsSecureGuard, InactivityGuard]
		},
	    {
			path: 'legal-analytics-public/:id', loadChildren: () => import('./legal-analytics-public/legal-analytics-public.module').then(m => m.LegalAnalyticsPublicModule),
			canActivate: [IsSecureGuard]
		},
		{
			path: 'portal-cliente', loadChildren: () => import('./portal-cliente/portal-cliente.module').then(m => m.PortalClienteModule)
		},
		{
			path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
			canActivate: [AuthGuard, IsSecureGuard, InactivityGuard]
		},
		{
			path: 'clm-sign',
			loadChildren: () =>
				import('./inprovider-sign/inprovider-sign.module').then((m) => m.InproviderSignModule),
			canActivate: [AuthGuard, IsSecureGuard, InactivityGuard, LexgosignEnabledGuard]
		},
		{
			path: 'inprovider-sign',
			redirectTo: 'clm-sign',
			pathMatch: 'prefix'
		},
		{
			path: 'test', loadChildren: () => import('./test-phase1/test.module').then(m => m.TestModule),
			canActivate: [AuthGuard, IsSecureGuard, InactivityGuard]
		},
		// {
		// 	path: 'common', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
		// 	canActivate: [AuthGuard, IsSecureGuard]
		// },
		// Verificar
		// {
		// 	path: 'maintenance/dashboard', loadChildren: () => import('./maintenance/maintenance.module').then(m => m.MaintenanceModule),
		// 	canActivate: [AuthGuard, IsSecureGuard]
		// },
		// {
		// 	path: 'configuration', loadChildren: () => import('./configuration/configuration.module').then(m => m.ConfigurationModule),
		// 	canActivate: [AuthGuard, IsSecureGuard]
		// },
		// {
		// 	path: 'activities', loadChildren: () => import('./activities/activities.module').then(m => m.ActivitiesModule),
		// 	canActivate: [AuthGuard, IsSecureGuard]
		// },
	  ],
	},
	// otherwise redirect to intro
	{ path: '**', redirectTo: '/' }
];

export const routing = RouterModule.forRoot(appRoutes, { scrollOffset: [0, 0], scrollPositionRestoration: 'top' });
